import log from 'Utilities/log';
import { removeSessionObject, setSessionObject } from './storage';

// TODO: change how to add the connections
const setConnections = connections => {
  setSessionObject('connections', connections);
  log.info('Success! Refresh your page.');
};
const enableBypassPhoneValidation = () => {
  setSessionObject('isBypassPhoneNumberEnabled', true);
  log.info('Phone bypass enabled');
};
const disableBypassPhoneValidation = () => {
  removeSessionObject('isBypassPhoneNumberEnabled');
  log.info('Phone bypass disabled');
};
window.testHelper = {
  setConnections,
  enableBypassPhoneValidation,
  disableBypassPhoneValidation
};